import type { FondoContable } from '../types';

export const CARD_BASE = 'bg-white rounded-xl border border-gray-200 shadow-sm';
export const LABEL_CLASS = 'text-xs font-semibold text-muted-foreground mb-1 block';
export const SECTION_LABEL_CLASS = 'text-xs font-semibold text-muted-foreground uppercase tracking-wider';
export const NATIVE_FIELD_CLASS =
  'h-9 w-full rounded-xl border border-gray-300 bg-white px-2 text-base md:text-sm text-gray-900 ' +
  'focus:outline-none focus:ring-1 focus:ring-primary/40 focus:border-primary';

export const FONDO_LABELS: Record<FondoContable, string> = {
  escrituras: 'Escrituras',
  certificaciones_poderes: 'Certificaciones y poderes',
};
